import { FormGroup } from 'Components/ComponentLibrary/ExternalLibraries';
import { styled } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const firstVisibleChild = ':nth-child(-n + 1 of :not([hidden]))';
const lastVisibleChild = ':nth-last-child(-n + 1 of :not([hidden]))';


/**
 * InputGroup
 *
 * This component is temporarily available until we figure out the solution via the Design System. Refrain from using
 * this component unless absolutely necessary.
 *
 * @deprecated
 */
const InputGroup = styled(FormGroup)(({ theme }) => ({
  width: '100%',
  flexDirection: 'row',
  alignItems: 'stretch',
  flexWrap: 'nowrap',
  '& > *': {
    flex: 1,
  },
  // remove all border radius from children
  // .FD-MuiInputBase-root needs to be selected as specified
  '& > *,& .MuiInputBase-root,& .MuiSelect-root': {
    borderRadius: 0,
    minWidth: 0,
    overflow: 'hidden',
  },
  // add dividers between children
  [`& > :not(${firstVisibleChild}) > .MuiInputBase-root`]: {
    borderLeft: `2px solid ${theme.palette.primary.light}`,
  },
  // add border radius to the left of the first element
  [`& > ${firstVisibleChild} > .MuiInputBase-root`]: {
    borderTopLeftRadius: theme.radius.md,
    borderBottomLeftRadius: theme.radius.md,
    overflow: 'hidden',
  },
  // add border radius to the right of the last element
  [`& > ${lastVisibleChild} > .MuiInputBase-root`]: {
    borderTopRightRadius: theme.radius.md,
    borderBottomRightRadius: theme.radius.md,
    overflow: 'hidden',
  },
  // set the last element to be slightly smaller than the other element
  [`& > :not(${lastVisibleChild})`]: {
    flex: '0 0.8 auto',
  },
  [`& > ${lastVisibleChild}`]: {
    flex: '0 1 auto',
  },
  // NOTE: this is a custom fix to allow wrapping helper text. we need to figure out a better solution.
  // we decided against applying this change to all helper texts since it will potentially affect all layouts.
  '& .MuiFormHelperText-root > .MuiTypography-root': {
    whiteSpace: 'normal',
  },
}));

export default InputGroup;
